import Vue from 'vue';
import App from './App.vue';
import { i18n } from '@/locale';
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'public/icons/style.css';
import 'assets/css/main.sass';
import VueResource from 'vue-resource';
import VueRouter from 'vue-router';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

Vue.use(Element);
Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(Element, {
    i18n: (key, value) => i18n.t(key, value)
});

const apiRoot = '/api/';

Vue.http.options.root = apiRoot;

new Vue({
    el: '#app',
    i18n,
    router,
    store,
    components: {
        App
    },
    template: '<App/>'
});
